export const fireRegisterEvent = () => {
  window.twttr && window.twttr.conversion.trackPid('o0jl7', { tw_sale_amount: 0, tw_order_quantity: 0 });
};
